/* ============================================================
   HERO VIDEO — playback + desktop framing

   1. PLAYBACK
      The hero video is autoplay/muted/playsinline, but on a
      slow connection Chrome and Safari can leave it parked at
      readyState 1 and never start. This nudges play() at every
      point where it could plausibly succeed, and once more on
      the visitor's first interaction, which satisfies browsers
      that require a gesture.

   2. FRAMING BACKDROP
      The master is 720x1280. Stretched edge to edge on a
      desktop screen that is a ~2x upscale, which is what reads
      as "low quality". The CSS (in snippets/seo-head.liquid)
      shows the video at its own aspect above 750px so it is
      DOWNscaled instead, and this script inserts the blurred
      plate that fills the space either side. Blur at this
      radius carries no detail, so the plate's own resolution
      is irrelevant.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var v = document.querySelector('.ulth-vid');
    if (!v) return;

    /* ---- backdrop ---- */
    var host = v.parentNode;
    if (host && !host.querySelector('.ulth-back')) {
      var poster = v.getAttribute('poster');
      if (poster) {
        var back = document.createElement('div');
        back.className = 'ulth-back';
        back.setAttribute('aria-hidden', 'true');
        back.style.backgroundImage = 'url("' + poster + '")';
        host.insertBefore(back, v);
      }
    }

    if (v.tagName !== 'VIDEO') return;

    /* ---- playback ---- */
    var settled = false;
    function go() {
      if (settled && !v.paused) return;
      var p = v.play();
      if (p && p.then) p.then(function () { settled = true; }, function () {});
    }

    v.addEventListener('loadeddata', go);
    v.addEventListener('canplay', go);
    v.addEventListener('stalled', go);
    v.addEventListener('pause', function () {
      /* only fight a pause the visitor did not ask for */
      if (!document.hidden) setTimeout(go, 120);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) go();
    });

    ['touchstart', 'pointerdown', 'scroll'].forEach(function (evt) {
      window.addEventListener(evt, go, { passive: true, once: true });
    });

    go();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
